import request from '@/utils/request'

export function getDictionaryList(obj) {
  // return request({
  //     url: `/tenantadmin/tenant/dict/item/list`,
  //     method: 'get',
  //     params: obj
  // });
  if (obj.dicCode === 'PROJECT_FORMAT') {
    return Promise.resolve({
      data: {
        "code": 0,
        "msg": null,
        "data": [
          {
            "createBy": "admin",
            "createTime": "2023-07-03 15:15:49",
            "updateBy": "admin",
            "updateTime": "2023-07-03 15:15:49",
            "deleted": "0",
            "tenantCode": "M0002",
            "id": "1714248578180775937",
            "publicItemId": "2",
            "dicCode": "PROJECT_FORMAT",
            "value": "商业",
            "label": "商业",
            "type": null,
            "description": null,
            "sortOrder": 0,
            "systemFlag": null
          },
          {
            "createBy": "admin",
            "createTime": "2023-07-03 15:15:49",
            "updateBy": "admin",
            "updateTime": "2023-07-03 15:15:49",
            "deleted": "0",
            "tenantCode": "M0002",
            "id": "1714248578180775938",
            "publicItemId": "3",
            "dicCode": "PROJECT_FORMAT",
            "value": "办公",
            "label": "办公",
            "type": null,
            "description": null,
            "sortOrder": 0,
            "systemFlag": null
          },
          {
            "createBy": "admin",
            "createTime": "2023-07-03 15:14:36",
            "updateBy": "admin",
            "updateTime": "2023-07-03 15:14:36",
            "deleted": "0",
            "tenantCode": "M0002",
            "id": "1714248578101084162",
            "publicItemId": "1",
            "dicCode": "PROJECT_FORMAT",
            "value": "住宅",
            "label": "住宅",
            "type": null,
            "description": null,
            "sortOrder": 0,
            "systemFlag": null
          },
          {
            "createBy": "admin",
            "createTime": "2023-07-03 15:15:49",
            "updateBy": "admin",
            "updateTime": "2023-07-03 15:15:49",
            "deleted": "0",
            "tenantCode": "M0002",
            "id": "1714248578180775939",
            "publicItemId": "4",
            "dicCode": "PROJECT_FORMAT",
            "value": "工业",
            "label": "工业",
            "type": null,
            "description": null,
            "sortOrder": 0,
            "systemFlag": null
          }
        ],
        "success": true
      }
    })
  }
}
